import styled from "@emotion/styled";
import { TreeNode } from "src/atoms/Tree/Tree.styled";

export const CategoryTreeNode = styled(TreeNode)`
  &:not(:last-of-type) {
    margin-bottom: ${({ theme }) => theme.space.space8};
  }

  &:first-of-type {
    margin-top: ${({ theme }) => theme.space.space8};
  }

  .childNode {
    margin-left: ${({ theme }) => theme.space.space16};
  }
`;
